import { reactSelectWithOptions } from 'ui';

export const pageSizeOptions = [
   { value: '25', label: '25' },
   { value: '50', label: '50' },
   { value: '100', label: '100' },
   { value: '250', label: '250' },
   { value: '500', label: '500' },
];
const PageSizeSelect = reactSelectWithOptions(
   pageSizeOptions,
);

PageSizeSelect.defaultProps = {
   required: false,
   value: '',
};

export default PageSizeSelect;
